<template>
  <section>
    <div class="cards" v-for="(item, index) in orderList" :key="index">
      <router-link :to="{path: '/orderinfo', query:{gst_id: item.ID}}">
        <div class="flex-between">
          <h4 class="shop-name">{{item.ROOM_TYPE_DESCR}}</h4>
          <p v-show="item.STATUS == 'RES'" class="primary">已预定</p>
          <p v-show="item.STATUS == 'D' || item.STATUS == 'I'" class="orange">本日到店</p>
          <p v-show="item.STATUS == 'IN'" class="green">在住中</p>
          <p v-show="item.STATUS == 'D' || item.STATUS == 'O'" class="orange">本日离店</p>
          <p v-show="item.STATUS == 'OUT'" class="gray">已退房</p>
          <p v-show="item.STATUS == 'CXL'" class="disabled">已取消</p>
          <p v-show="item.STATUS == 'NS'">未到店</p>
        </div>
        <div class="table-no mv-1x">使用时间：{{item.ARRIVAL_DATE | date }} 至 {{item.DEPARTURE_DATE | date }}</div>
        <p>总价：<span class="red">￥{{item.RATE}}</span></p>
      </router-link>
    </div>
    <p class="empty" v-if="empty">—— 暂无订单 ——</p>
  </section>
</template>

<script>
// import { getOrderList } from '@/api/getData'
import { getStore } from '../config/utils'
export default {
  data() {
    return {
      orderList: [], // 订单列表
      shopName: '',
      empty: false,
    }
  },
  created() {
    // 初始化订单列表
    this.handleGetOrderList(),
    this.shopName = getStore('setShop')
  },
  filters: {
    date(val) {
      let arr = val.split('/')
      arr = arr.reverse()
      return arr.join('-')
    }
  },
  methods: {
    // 获取订单信息
    handleGetOrderList() {
      this.$fetch({
        url: '/api/Reservation/enquiryByMemberID'
      })
        .then(({folio}) => {
          folio.sort((a,b) => {
            let t1 = a.ARRIVAL_DATE.split('/')
            let date1 = new Date(t1[2], t1[1], t1[0]).getTime()
            let t2 = b.ARRIVAL_DATE.split('/')
            let date2 = new Date(t2[2], t2[1], t2[0]).getTime()
            return date2 - date1
          })
          this.orderList = folio
          this.empty = folio.length === 0
        })
    },
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/var.less';
.myorder-wrap {
  .main {
    .order-list{
      .item{
        display: flex;
        background: #ffffff;
        padding: 10px;
        flex: 1;
        box-sizing: border-box;
        overflow-y: scroll;
        border-bottom: 8px solid #f1f1f1;
        >a{
          display: flex;
          width: 100%;
          text-decoration: none;
          color: #000;
        }
        .item-left{
          flex: 1;
          color: #666;
          .shop-name{
            font-weight: 600;
            font-size: .7rem;
            color: #000;
          }
          .table-no{
            margin: 6px 0;
          }
          .time{
            color: #a9a9a9;
          }
          .order-number{
            color: #a9a9a9;
          }
        }
        .item-right{
          display: flex;
          flex-direction: column;
          text-align: center;
          .item-status{
            color: @fristColor;
            font-size: 14px;
            flex: 1;
          }
          .is-out{
            color: #de0303;
          }
          .no-pay{
            color:#fd9c1a
          }
          .status{
            color: #599af9;
          }
        }
      }
      .tips{
        text-align: center;
        margin: 15px;
        color: #9b9b9b;
      }
    }
  }
}
</style>


